import { BulkUpload as RestBulkUpload } from "../rest-model/BulkUpload";
import { BulkUpload } from "../domain/BulkUpload";

/**
 * Converts the User Management API's bulk upload wire shape into the domain model.
 *
 * The timestamps and the failure entries need converting; everything else is carried over by name
 * via `...rest`. The entries are rebuilt as plain objects rather than spread through: the rest model
 * stores them as `BulkUploadFailedEntry` class instances, and the two shapes are structurally
 * compatible, so spreading them would silently seat rest-model instances inside the domain.
 *
 * Read-only feature — there is no `adaptToRest` counterpart because nothing is written back.
 */
export class BulkUploadAdapter {
    public adaptToDomain({ uploadedAt, startTime, endTime, failedEmails, ...rest }: RestBulkUpload): BulkUpload {
        return new BulkUpload({
            // Guarded for the same reason as the stamps below: a row missing its timestamp should
            // stay undefined rather than become an Invalid Date the table has to detect.
            uploadedAt: uploadedAt ? new Date(uploadedAt) : undefined,
            // Absent until the blob-trigger job records them; keep them undefined rather than
            // turning a missing value into an Invalid Date.
            startTime: startTime ? new Date(startTime) : undefined,
            endTime: endTime ? new Date(endTime) : undefined,
            failedEmails: failedEmails?.map(({ email, reason, detail }) => ({ email, reason, detail })),
            ...rest
        });
    }
}
